import { MainContent } from "shared/styles";
import { EditMemberForm } from "Bands/containers";
import { Card } from "shared/components";
import { copy } from "shared/assets";
import { User } from "shared/assets/icons";

export const EditMemberPage = () => {
  return (
    <MainContent>
      <Card title={copy.members.editMember.title} icon={User}>
        <EditMemberForm />
      </Card>
    </MainContent>
  );
};
